import createDOMPurify from "dompurify";

const domPurify = typeof window === "undefined" ? undefined : createDOMPurify(window);

export const getWidthAdjustedSVG = (legend: string) => {
  const parser = new DOMParser();
  const sanitizedLegend = domPurify?.sanitize(legend, { USE_PROFILES: { svg: true } }) ?? legend;
  const doc = parser.parseFromString(sanitizedLegend, "image/svg+xml");

  const svgElement = doc.querySelector("svg");
  if (!svgElement) {
    return;
  }
  const textElements = Array.from(svgElement.querySelectorAll("text"));
  if (textElements.length === 0) {
    return;
  }

  const charWdithInPixel = 7;
  const newWidth = Math.ceil(
    textElements.reduce((maxWidth, textElement) => {
      const charCount = (textElement.textContent || "").length;
      const xCoordinate = Number.parseFloat(textElement.getAttribute("x") || "0");
      const estimatedTextWidth = charCount * charWdithInPixel;
      return Math.max(maxWidth, xCoordinate + estimatedTextWidth);
    }, 0),
  );
  svgElement.setAttribute("preserveAspectRatio", "xMidYMid meet");
  svgElement.style.width = "100%";
  svgElement.style.height = "100%";

  // Adjust the viewBox and width
  const currentViewBox = svgElement.getAttribute("viewBox")?.split(" ").map(Number);
  if (currentViewBox && currentViewBox.length === 4) {
    const newViewBox = `0 ${currentViewBox[1]} ${newWidth} ${currentViewBox[3]}`;
    svgElement.setAttribute("viewBox", newViewBox);
    svgElement.setAttribute("width", newWidth.toString());
  }

  svgElement.querySelector("rect")?.remove();

  return svgElement;
};
